<template>
  <div class="header">
    <div class="header_left">
      <img src="@/assets/img/1.png" alt />
      <p>企业大数据平台</p>
    </div>
    <div class="header_rightBox">
      <div class="headerCenter">
        <div v-for="(v,i) in navData" :key="i">
          <router-link
            tag="p"
            :to="v.title_code?v.title_code=='/'?v.title_code:'/' + v.title_code:''"
            v-if="v.childrenList.length==0"
          >{{v.title_name}}</router-link>
          <div class="tssj" :class="'tssj' + i" v-else>
            <h3>{{v.title_name}}</h3>
            <i
              class="el-icon-caret-top"
              style="position: absolute;top: 41px;left: 23px;"
              v-show="i==1?tssjShow:i==2?tssjShow_1:''"
            ></i>
            <div :class="'tssjHover'+i" v-show="i==1?tssjShow:i==2?tssjShow_1:''">
              <router-link
                tag="span"
                style="text-align: left;text-indent: 15px;"
                :to="s.title_code?'/' + s.title_code:''"
                v-for="(s,k) in v.childrenList"
                :key="k"
              >{{s.title_name}}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="header_right" :style="users.token?'width:auto;':''">
        <span v-show="users.token">您好，{{users.userName}}</span>
        <span v-show="users.token">|</span>
        <span v-show="users.token" @click="addCollect" style="cursor: pointer;">我的关注</span>
        <span v-show="users.token">|</span>
        <span v-show="users.token" @click="unloginFn" style="cursor: pointer;">退出登录</span>
        <span v-show="!users.token" @click="goLoginPage" style="cursor: pointer;">登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import $ from "jquery";

export default {
  props: {},
  components: {},
  data() {
    return {
      users: "",
      guid: "",
      navData: [],
      tssjShow_1: "", //控制nav展示
      tssjShow: "" //控制nav展示
    };
  },
  computed: {},
  watch: {
    guid(val) {
      if (val) {
        this.loginFn();
      }
    }
  },
  methods: {
    // 收藏
    addCollect() {
      this.$router.push({
        path: "/storeup",
        query: {
          dbcode: this.$route.query.dbcode ? this.$route.query.dbcode : 2
        }
      });
    },
    //跳往登录页面
    goLoginPage() {
      this.$router.push({
        path: "/login",
        query: {
          repath: window.location.href
        }
      });
    },
    loginFn() {
      let _this = this;
      let tmpGuid = this.guid;
      api.iflogin(tmpGuid).then(res => {
        if (res.UserToken) {
          let usersInfo = localStorage.getItem("usersInfo")
            ? JSON.parse(localStorage.getItem("usersInfo"))
            : "";

          let tmpObj = {
            loginId: res.Logined,
            token: res.UserToken,
            userName: res.UserName,
            rights: usersInfo ? usersInfo.rights : 0,
            userId: res.userId
          };

          localStorage.setItem("usersInfo", JSON.stringify(tmpObj));

          sessionStorage.setItem("Authorization", res.UserToken);

          _this.users = tmpObj;

          _this.$emit("getLoginInfo", tmpObj);
        } else {
          localStorage.removeItem("usersInfo");

          sessionStorage.removeItem("Authorization");

          _this.users = "";

          _this.$emit("getLoginInfo", "");
        }
      });
    },
    //退出登录
    unloginFn() {
      let _this = this;
      let tmpGuid = this.guid;
      api.unlogin(tmpGuid).then(res => {
        $.ajax({
          url: "http://d.drcnet.com.cn/login/login.ashx?flag=logoutp", //initp 查询目前用户登录状态，logoutp 退出登录
          type: "post",
          dataType: "jsonp", //指定服务器返回的数据类型
          jsonpCallback: "showDatas", //指定回调函数名称
          xhrFields: { withCredentials: true },
          crossDomain: true,
          async: false,
          success: function(data) {
            if (!res.code) {
              localStorage.removeItem("usersInfo");

              sessionStorage.removeItem("Authorization");

              _this.users = "";

              _this.$emit("getLoginInfo", "");

              // window.history.go(0);
            }
          }
        });
      });
    },
    figgerPrint() {
      let _this = this;

      // let myOptions = {
      //   excludes: {
      //     language: true,
      //     colorDepth: true,
      //     deviceMemory: true,
      //     pixelRatio: true,
      //     availableScreenResolution: true,
      //     timezoneOffset: true,
      //     timezone: true,
      //     sessionStorage: true,
      //     localStorage: true,
      //     indexedDb: true,
      //     addBehavior: true,
      //     openDatabase: true,
      //     cpuClass: true,
      //     doNotTrack: true,
      //     plugins: true,
      //     canvas: true,
      //     webglVendorAndRenderer: true,
      //     adBlock: true,
      //     hasLiedLanguages: true,
      //     hasLiedResolution: true,
      //     hasLiedOs: true,
      //     hasLiedBrowser: true,
      //     touchSupport: true,
      //     audio: false,
      //     enumerateDevices: true,
      //     hardwareConcurrency: true,
      //   },
      // };
      let myOptions = getDRCNetFingerConfig();
      // console.log(myOptions,'myOptions')
      if (window.requestIdleCallback) {
        Fingerprint2.get(myOptions, function(components) {
          // console.log(components,'components');
          var option = components
            .filter(function(pair) {
              if (
                pair.key == "userAgent" ||
                pair.key == "availableScreenResolution"
              ) {
                return false;
              }
              return true;
            })
            .map(function(pair) {
              return pair.value;
            });
          var murmur = Fingerprint2.x64hash128(option.join(), 31);
          // document.querySelector("#fp").textContent = murmur;
          _this.guid = murmur;
          // console.log(murmur, "murmur1");
        });
      } else {
        setTimeout(() => {
          Fingerprint2.get(myOptions, function(components) {
            // console.log(components,'components');
            var option = components
              .filter(function(pair) {
                if (
                  pair.key == "userAgent" ||
                  pair.key == "availableScreenResolution"
                ) {
                  return false;
                }
                return true;
              })
              .map(function(pair) {
                return pair.value;
              });
            var murmur = Fingerprint2.x64hash128(option.join(), 31);
            // document.querySelector("#fp").textContent = murmur;
            _this.guid = murmur;
            console.log(murmur, "murmur2");
          });
        }, 500);
      }
    },
    getIndexTitle() {
      api.getIndexTitle().then(res => {
        this.navData = res.data;
        this.$nextTick(() => {
          $(".tssjHover").hover(
            m => {},
            s => {
              this.tssjShow = false;
              this.tssjShow_1 = false;
            }
          );
          $(".tssj1").hover(
            m => {
              this.tssjShow = true;
            },
            s => {
              this.tssjShow = false;
            }
          );
          $(".tssj2").hover(
            m => {
              this.tssjShow_1 = true;
            },
            s => {
              this.tssjShow_1 = false;
            }
          );
        });
      });
    }
    //  ifRightsFn() {
    // return new Promise(function(resolve, reject) {
    // let productId = "";
    // if (that.$route.query.dbcode) {
    //   productId =
    //     that.$route.query.dbcode == 2
    //       ? 0
    //       : that.$route.query.dbcode == 1
    //       ? 1
    //       : "";
    // }

    // if (that.$route.params.dbcode) {
    //   productId =
    //     that.$route.params.dbcode == 2
    //       ? 0
    //       : that.$route.params.dbcode == 1
    //       ? 1
    //       : "";
    // }

    // if (productId == 0 || productId == 1) {
    // api.weighterRights(1).then(res => {
    //   console.log(res);
    // resolve(res.data);
    // });
    // } else {
    // resolve(false);
    // }
    // });
    // },
  },
  created() {
    this.getIndexTitle();
    this.figgerPrint();
    // this.ifRightsFn();
  },
  mounted() {}
};
</script>
<style scoped lang="less">
.header {
  width: 100%;
  height: 52px;
  line-height: 52px;
  justify-content: space-between;
  background: #126bc1;
  display: flex;
  z-index: 99;
}
.header_rightBox {
  display: flex;
}
.header_left {
  width:auto;
  height: 40px;
  line-height: 40px;
  padding-top: 5px;
  padding-left: 25px;
  float: left;
  white-space:nowrap;
  img {
    width: 101px;
    height: 40px;
    float: left;
  }
  p {
    display: inline-block;
    text-align: center;
    line-height: 40px;
    float: left;
    margin-left: 15px;
    color: #fff;
    font-size: 16px;
  }
}
.headerCenter {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  div {
    width: 64px;
    height: 52px;
    text-align: center;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    margin-right: 57px;
  }
  .tssj {
    width: 100%;
    position: relative;
    h3 {
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }

    .tssjHover1 {
      width: 150px;
      height: auto;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      display: flex;
      justify-content: space-around;
      position: absolute;
      background: #fff;
      flex-direction: column;
      z-index: 99999;
      span {
        cursor: pointer;
        text-align: center;
        color: #000;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      span:hover {
        color: skyblue;
        background: #f2f7fd;
        border-radius: 2px;
      }
    }
    .tssjHover2 {
      width: 150px;
      height: auto;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      display: flex;
      justify-content: space-around;
      position: absolute;
      background: #fff;
      flex-direction: column;
      z-index: 99999;
      span {
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        text-align: center;
        color: #000;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      span:hover {
        color: skyblue;
        background: #f2f7fd;
        border-radius: 2px;
      }
    }
  }
}

.header_right {
  width: 106px;
  height: 52px;
  background: #3c98f5;
  border-radius: 1px;
  align-items: center;
  text-align: center;
  padding: 0 20px; white-space:nowrap;
  span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(236, 241, 248, 1);
    padding-right: 5px;
  }
  .user {
    transform: translate(0, 25%);
    width: 26px;
    height: 26px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue